import "./HPForm.scss";
import Spinner from "../../../components/Spinner/Spinner";
import Buttons from "../../../components/Buttons/Buttons";
import ErrorAlert from "../../../components/ErrorAlert/ErrorAlert";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { BackArrow } from "../../../assets/icons-components/Icons";
import useHPForm from "./useHPForm";
import HPBasicInfoFields from "./HPBasicInfoFields";
import DeviceAssignmentSection from "./DeviceAssignmentSection";
import { onKeyActivate } from "../../../utils/a11y";

const HPForm = () => {
  const {
    errors,
    formData,
    messages,
    openConfirmModal,
    openResultModal,
    removedDevicesResponse,
    isLoading,
    assignDevices,
    numberOfUsers,
    isEditing,
    resetPassword,
    secondaryEmails,
    newSecondaryEmail,
    secondaryEmailError,
    mergedDevices,
    setOpenConfirmModal,
    setOpenResultModal,
    handleChange,
    handleNewSecondaryEmailChange,
    handleAddSecondaryEmail,
    handleDeleteSecondaryEmail,
    handleEditSecondaryEmail,
    editingIndex,
    editingEmail,
    setEditingEmail,
    handleSaveEditSecondaryEmail,
    handleCancelEditSecondaryEmail,
    toggleDeviceSelection,
    onResetPasswordClick,
    handleSubmit,
    handleTable,
    handleYesClick,
    handleNoClick,
    handleResultOk,
  } = useHPForm();

  return (
    <div className="hp-form-container">
            {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <div className="hp-form-container_header">
        <div className="hp-form-container_header_left">
          <div
            className="hp-form-container_header_left_arrow"
            onClick={handleTable}
            onKeyDown={onKeyActivate(handleTable)}
            role="button"
            tabIndex={0}
          >
            <BackArrow onClick={handleTable} />
            <h3>{isEditing ? "Edit Healthcare Professional" : "Add Healthcare Professional"}</h3>
          </div>
        </div>
      </div>
      <div className="hp-form-container_formdetails">
        <div className="form-section basic-info-section">
          <div className="form-section-header">
            <div className="form-section-header-left">
              <h4 className="form-section-title">Basic Information</h4>
              <p className="form-section-subtitle">Provide basic registration details and authentication credentials.</p>
            </div>
          </div>
          <div className="hp-form-container_formdetails_container">
            <HPBasicInfoFields
              formData={formData}
              errors={errors}
              isEditing={isEditing}
              resetPassword={resetPassword}
              onChange={handleChange}
              onResetPasswordClick={onResetPasswordClick}
            />
          </div>
        </div>

        <hr className="form-divider" />

        <DeviceAssignmentSection
          mergedDevices={mergedDevices}
          assignDevices={assignDevices}
          errors={errors}
          formData={formData}
          numberOfUsers={numberOfUsers}
          onToggleDevice={toggleDeviceSelection}
          onChangeDescription={handleChange}
          secondaryEmails={secondaryEmails}
          newSecondaryEmail={newSecondaryEmail}
          secondaryEmailError={secondaryEmailError}
          handleNewSecondaryEmailChange={handleNewSecondaryEmailChange}
          handleAddSecondaryEmail={handleAddSecondaryEmail}
          handleDeleteSecondaryEmail={handleDeleteSecondaryEmail}
          handleEditSecondaryEmail={handleEditSecondaryEmail}
          editingIndex={editingIndex}
          editingEmail={editingEmail}
          setEditingEmail={setEditingEmail}
          handleSaveEditSecondaryEmail={handleSaveEditSecondaryEmail}
          handleCancelEditSecondaryEmail={handleCancelEditSecondaryEmail}
        />

        <div className="hp-form-container_formdetails_buttons">
          <div className="hp-form-container_formdetails_buttons_cont">
            <div className="hp-form-container_formdetails_buttons_cont_sec">
              <Buttons
                text="Cancel"
                type="button"
                onClick={handleTable}
                className="cancel-button"
                variant="secondary"
                style={{ width: "120px" }}
              />
              <Buttons
                text="Save"
                type="button"
                onClick={handleSubmit}
                className="save-button"
                variant="primary"
                style={{ width: "120px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmDialog
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        title="Confirm Device Unassignment"
        severity="warning"
        content={messages}
        buttonText="YES"
        additionalButtonText="NO"
        onButtonClick={handleYesClick}
        onAdditionalButtonClick={handleNoClick}
      />

      <ErrorAlert
        open={openResultModal}
        onClose={() => setOpenResultModal(false)}
        content={
          <div>
            <p>{messages}</p>
            {removedDevicesResponse?.length > 0 && (
              <ul style={{ marginTop: "8px", paddingLeft: "18px" }}>
                {removedDevicesResponse.map((item) => (
                  <li key={`${item.deviceId}-${item.patientId}`}>
                    <strong>{item.deviceName}</strong>
                  </li>
                ))}
              </ul>
            )}
          </div>
        }
        buttonText="OK"
        onButtonClick={handleResultOk}
      />
    </div>
  );
};

export default HPForm;
